import { render } from "./AgentIndex.vue?vue&type=template&id=1c994f2e"
import script from "./AgentIndex.vue?vue&type=script&lang=js"
export * from "./AgentIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__